
// Props extended interface
export interface IconProps{
    readonly id: string
    readonly size?: number
    readonly color?: string
    readonly config?: any
}   

export interface SVGIconProps {
  readonly fill?: string
  readonly viewDim: string
  readonly viewDimY?: string
  readonly paths: IconPath[]
} 

// Icon map object type
export type IconsMap = Record<
  string,
  SVGIconProps
>

// SVG path interface
export interface IconPath {
  readonly d: string 
  readonly fill?: string
  readonly fillRule?: "nonzero" | "evenodd" | "inherit" | undefined
  readonly clipRule?: "nonzero" | "evenodd" | "inherit" | undefined
  readonly fillOpacity: string
}

// Icons map
const iconsMap: IconsMap = {

  cartDefault: {
    viewDim: '23',
    paths: [
      {
        d: 'M23.0448 7.72655V11.3203C23.0448 11.8166 22.6426 12.2187 22.1463 12.2187H21.5555L21.177 15.5874C21.1254 16.0464 20.7366 16.3854 20.2852 16.3856C20.2517 16.3856 20.218 16.3837 20.1838 16.3798C19.6907 16.3245 19.3359 15.8797 19.3914 15.3868L19.8595 11.2201C19.9106 10.7656 20.2949 10.4219 20.7524 10.4219H21.2481V8.62499H1.8418V10.4219H17.1602C17.6564 10.4219 18.0586 10.8242 18.0586 11.3203C18.0586 11.8166 17.6564 12.2187 17.1602 12.2187H3.35897L4.24618 19.6202C4.35427 20.5226 5.12128 21.2031 6.03025 21.2031H17.1316C18.0472 21.2031 18.8149 20.5169 18.9172 19.6068C18.9725 19.1137 19.4172 18.7591 19.9102 18.8144C20.4033 18.8698 20.7582 19.3145 20.7029 19.8076C20.4983 21.6274 18.963 23 17.1316 23H6.03025C4.21231 23 2.6783 21.6388 2.46193 19.8339L1.54928 12.2187H0.943361C0.447114 12.2187 0.0449219 11.8166 0.0449219 11.3203V7.72655C0.0449219 7.23031 0.447114 6.82811 0.943361 6.82811H4.13001L8.87752 0.366547C9.17127 -0.0331882 9.7335 -0.119347 10.1334 0.174576C10.5333 0.468323 10.6193 1.03055 10.3256 1.43046L6.35979 6.82811H16.7633L12.7973 1.43046C12.5036 1.03055 12.5896 0.468323 12.9895 0.174576C13.3894 -0.119347 13.9516 -0.0333637 14.2455 0.366547L18.9929 6.82811H22.1463C22.6426 6.82811 23.0448 7.23048 23.0448 7.72655ZM10.6465 14.9141V18.5078C10.6465 19.0041 11.0487 19.4063 11.5449 19.4063C12.041 19.4063 12.4434 19.0041 12.4434 18.5078V14.9141C12.4434 14.4178 12.041 14.0156 11.5449 14.0156C11.0487 14.0156 10.6465 14.4178 10.6465 14.9141ZM14.2403 14.9141V18.5078C14.2403 19.0041 14.6424 19.4063 15.1387 19.4063C15.6348 19.4063 16.0371 19.0041 16.0371 18.5078V14.9141C16.0371 14.4178 15.6348 14.0156 15.1387 14.0156C14.6424 14.0156 14.2403 14.4178 14.2403 14.9141ZM7.05275 14.9141V18.5078C7.05275 19.0041 7.45494 19.4063 7.95119 19.4063C8.44726 19.4063 8.84962 19.0041 8.84962 18.5078V14.9141C8.84962 14.4178 8.44726 14.0156 7.95119 14.0156C7.45494 14.0156 7.05275 14.4178 7.05275 14.9141Z',
        fillOpacity: '1',
      }
    ],
  },
	
	cartCustom: {
		viewDim: '24',
		paths: [
			{
				d: "M4.49981 0.400897C4.68908 0.148528 4.98612 0 5.30157 0H18.4992C18.8146 0 19.1117 0.148528 19.3009 0.400897L22.6003 4.80044C22.7304 4.97391 22.8007 5.18489 22.8007 5.40171V20.7986C22.8007 21.6476 22.4635 22.4619 21.8631 23.0623C21.2627 23.6627 20.4484 24 19.5993 24H4.20143C3.35235 24 2.53806 23.6627 1.93768 23.0623C1.33729 22.4619 1 21.6476 1 20.7986V5.40171C1 5.18489 1.07032 4.97391 1.20041 4.80044L4.49981 0.400897ZM5.80268 2.00433L4.00641 4.39954H19.7943L17.9981 2.00433H5.80268ZM20.7964 6.40388H3.00433V20.7986C3.00433 21.1161 3.13046 21.4205 3.35495 21.645C3.57945 21.8695 3.88394 21.9957 4.20143 21.9957H19.5993C19.9168 21.9957 20.2213 21.8695 20.4458 21.645C20.6703 21.4205 20.7964 21.1161 20.7964 20.7986V6.40388ZM7.48551 8.79818C8.03892 8.78972 8.49442 9.23149 8.50288 9.78491C8.51651 10.6769 8.88041 11.5276 9.51598 12.1536C10.1516 12.7795 11.0078 13.1304 11.8999 13.1304C12.7919 13.1304 13.6482 12.7795 14.2837 12.1536C14.9193 11.5276 15.2832 10.6769 15.2968 9.78491C15.3053 9.23149 15.7608 8.78972 16.3142 8.79818C16.8676 8.80664 17.3094 9.26213 17.3009 9.81555C17.2793 11.2337 16.7007 12.5864 15.6901 13.5816C14.6796 14.5769 13.3182 15.1347 11.8999 15.1347C10.4815 15.1347 9.12012 14.5769 8.10958 13.5816C7.09904 12.5864 6.52046 11.2337 6.49878 9.81555C6.49032 9.26213 6.93209 8.80664 7.48551 8.79818Z",
				fillRule: 'evenodd',
				clipRule: 'evenodd',
				fillOpacity: '1'
			}
		]
	},
  
  cross: {
    viewDim: '16',
    paths: [
      {
        d: 'M15.6095 15.0336L0.942809 3.56611e-06L0 0.9664L14.6667 16L15.6095 15.0336Z',
        fillOpacity: '1',
        fillRule: 'evenodd'
      },
      {
        d: 'M0.390525 15.0336L15.0572 3.56611e-06L16 0.9664L1.33333 16L0.390525 15.0336Z',
        fillOpacity: '1',
        fillRule: 'evenodd'
      },
    ],
  },
  emptyCart: {
    viewDim: '175',
    viewDimY: '219',
    paths: [
      {
        d: 'M174.955 188.995L162.436 48.0199C162.168 44.8901 159.53 42.5204 156.445 42.5204H130.691C130.333 19.0023 111.108 0 87.5 0C63.8924 0 44.6666 19.0023 44.3089 42.5204H18.5552C15.4254 42.5204 12.8321 44.8901 12.5639 48.0199L0.0447123 188.995C0.0447123 189.173 0 189.352 0 189.531C0 205.582 14.71 218.638 32.8181 218.638H142.182C160.29 218.638 175 205.582 175 189.531C175 189.352 175 189.173 174.955 188.995ZM87.5 12.072C104.446 12.072 118.261 25.6643 118.619 42.5204H56.3809C56.7386 25.6643 70.5544 12.072 87.5 12.072ZM142.182 206.566H32.8181C21.4614 206.566 12.2509 199.055 12.0721 189.799L24.0547 54.6372H44.2642V72.9688C44.2642 76.3222 46.9469 79.0048 50.3002 79.0048C53.6535 79.0048 56.3362 76.3222 56.3362 72.9688V54.6372H118.619V72.9688C118.619 76.3222 121.302 79.0048 124.655 79.0048C128.008 79.0048 130.691 76.3222 130.691 72.9688V54.6372H150.901L162.928 189.799C162.749 199.055 153.494 206.566 142.182 206.566Z',
        fillOpacity: '1',
      },
      {
        d: 'M85.9352 163.563C70.0719 165.554 54.2294 172.443 44.5568 178.199C42.1837 179.611 39.1152 178.832 37.7031 176.459C36.2911 174.086 37.0701 171.017 39.4432 169.605C49.9372 163.361 67.0948 155.85 84.6897 153.641C102.283 151.432 121.436 154.455 133.973 170.867C135.65 173.061 135.23 176.199 133.035 177.875C130.841 179.552 127.703 179.132 126.027 176.937C116.563 164.549 101.801 161.571 85.9352 163.563Z',
        fillOpacity: '1',
        clipRule: 'evenodd'
      },
      {
        d: 'M73 112C73 118.075 68.0751 123 62 123C55.9249 123 51 118.075 51 112C51 105.925 55.9249 101 62 101C68.0751 101 73 105.925 73 112Z',
        fillOpacity: '1',
      },
      {
        d: 'M120 112C120 118.075 115.075 123 109 123C102.925 123 98 118.075 98 112C98 105.925 102.925 101 109 101C115.075 101 120 105.925 120 112Z',
        fillOpacity: '1',
      },
    ],
  },
  expressShippingInfo: {
    viewDim: '15',
    paths: [
      {
        fillOpacity: '1',
        d: "M6.25586 5.85691C6.25586 7.7527 8.55968 8.7242 9.91235 7.37152C10.7493 6.53458 10.7495 5.17945 9.91235 4.3423C8.57396 3.0039 6.25586 3.94318 6.25586 5.85691V5.85691ZM9.32155 6.78099C8.50937 7.59317 7.09112 7.02967 7.09112 5.85691C7.09112 4.68863 8.50647 4.11711 9.32155 4.93311C9.83312 5.44412 9.83156 6.27212 9.32155 6.78099Z",
    },
    {
        fillOpacity: '1',
        d: "M13.06 0.00500969C10.3628 0.259542 7.12481 1.06782 4.98409 2.75748C4.03134 2.40667 2.91821 2.61325 2.15451 3.37696L0.337258 5.19394C0.093473 5.43772 0.23466 5.85705 0.576699 5.90307L2.65901 6.184L2.06736 8.04441C1.98551 8.30167 2.05344 8.57981 2.24416 8.77053L5.48386 12.0102C5.67502 12.2014 5.95311 12.2684 6.20998 12.187L8.07038 11.5954L8.35131 13.6777C8.39753 14.0213 8.81791 14.1597 9.06045 13.9171L10.8774 12.0999C11.6411 11.3362 11.8477 10.223 11.4969 9.27029C13.1918 7.12275 13.9944 3.8958 14.2494 1.19442C14.3142 0.512459 13.7417 -0.059751 13.06 0.00500969V0.00500969ZM1.52444 5.18809L2.74504 3.96749C3.1507 3.56183 3.69946 3.38448 4.23041 3.43515C3.65993 4.0229 3.22448 4.6758 2.92852 5.38688C2.86899 5.36561 2.96048 5.38193 1.52444 5.18809V5.18809ZM6.02427 11.3696L2.8848 8.23011L3.26624 7.03096L7.22343 10.9881L6.02427 11.3696ZM10.2869 11.5094L9.06629 12.7299C8.87179 11.289 8.88838 11.3843 8.8675 11.3259C9.57859 11.0299 10.2315 10.5945 10.8192 10.024C10.8699 10.5549 10.6925 11.1037 10.2869 11.5094V11.5094ZM8.12495 10.7083L3.54605 6.12943C4.38958 3.45921 7.25049 2.07482 9.96364 1.38403C10.2449 2.85336 11.3993 4.00912 12.8704 4.29074C12.1804 7.00075 10.8002 9.86319 8.12495 10.7083V10.7083ZM13.418 1.11563C13.3427 1.90821 13.2139 2.73871 13.0594 3.47692H13.0591C11.8962 3.26949 10.9849 2.35822 10.7775 1.19526V1.19498C11.5264 1.03817 12.3339 0.912828 13.1387 0.836374C13.2988 0.821451 13.433 0.955176 13.418 1.11563Z",
    },
    {
        fillOpacity: '1',
        d: "M1.81311 9.81021C1.80556 9.57967 1.61264 9.39909 1.38203 9.40647L0.403965 9.43849C0.173433 9.44603 -0.00731731 9.63903 0.000227884 9.86957C0.00763387 10.0954 0.193034 10.2735 0.417385 10.2735C0.422007 10.2735 0.426657 10.2735 0.431306 10.2733L1.40937 10.2413C1.6399 10.2337 1.82065 10.0407 1.81311 9.81021V9.81021Z",
    },
    {
        fillOpacity: '1',
        d: "M4.44575 12.4421C4.21591 12.4348 4.02224 12.6153 4.01467 12.8458L3.98265 13.8239C3.9751 14.0544 4.15585 14.2474 4.38639 14.255C4.39104 14.2551 4.39566 14.2552 4.40031 14.2552C4.62463 14.2552 4.81006 14.0771 4.81747 13.8512L4.84948 12.8732C4.85706 12.6427 4.67631 12.4497 4.44575 12.4421V12.4421Z",
    },
    {
        fillOpacity: '1',
        d: "M2.60315 11.062L1.67506 11.9901C1.51196 12.1532 1.51196 12.4176 1.67506 12.5807C1.83813 12.7438 2.10257 12.7439 2.26567 12.5807L3.19376 11.6527C3.35686 11.4896 3.35686 11.2251 3.19376 11.062C3.03069 10.8989 2.76624 10.8989 2.60315 11.062Z"
    }
    ],
  },
  shippingInfo: {
    viewDim: '18',
    viewDimY: '13',
    paths: [
      {
        d: "M13.2688 8.25732C12.0802 8.25732 11.1133 9.22428 11.1133 10.4129C11.1133 11.6015 12.0802 12.5684 13.2688 12.5684C14.4576 12.5684 15.4244 11.6015 15.4244 10.4129C15.4244 9.22428 14.4574 8.25732 13.2688 8.25732ZM13.2688 11.4906C12.6745 11.4906 12.1911 11.0073 12.1911 10.4129C12.1911 9.81849 12.6745 9.3351 13.2688 9.3351C13.8632 9.3351 14.3466 9.81849 14.3466 10.4129C14.3466 11.0073 13.8632 11.4906 13.2688 11.4906Z",
        fillOpacity: '1'
    },
    {
        d: "M5.90164 8.25732C4.71305 8.25732 3.74609 9.22428 3.74609 10.4129C3.74609 11.6015 4.71305 12.5684 5.90164 12.5684C7.09024 12.5684 8.0572 11.6015 8.0572 10.4129C8.0572 9.22428 7.09024 8.25732 5.90164 8.25732ZM5.90164 11.4906C5.30726 11.4906 4.82387 11.0073 4.82387 10.4129C4.82387 9.81849 5.30726 9.3351 5.90164 9.3351C6.49586 9.3351 6.97942 9.81849 6.97942 10.4129C6.97942 11.0073 6.49603 11.4906 5.90164 11.4906Z",
        fillOpacity: '1'
    },
    {
        d: "M14.7201 2.08704C14.6285 1.90508 14.4422 1.79028 14.2385 1.79028H11.4004V2.86806H13.9062L15.3736 5.78667L16.3368 5.30237L14.7201 2.08704Z",
        fillOpacity: '1'
    },
    {
        d: "M11.6498 9.89209H7.57227V10.9699H11.6498V9.89209Z",
        fillOpacity: '1'
    },
    {
        d: "M4.28589 9.89209H2.41778C2.12012 9.89209 1.87891 10.1333 1.87891 10.431C1.87891 10.7286 2.12015 10.9698 2.41778 10.9698H4.28592C4.58358 10.9698 4.8248 10.7286 4.8248 10.431C4.8248 10.1333 4.58355 9.89209 4.28589 9.89209Z",
        fillOpacity: '1'
    },
    {
        d: "M17.3395 6.59752L16.2796 5.23234C16.1777 5.10085 16.0206 5.02396 15.854 5.02396H11.9381V1.25176C11.9381 0.954103 11.6969 0.712891 11.3992 0.712891H2.41778C2.12012 0.712891 1.87891 0.954137 1.87891 1.25176C1.87891 1.54939 2.12015 1.79063 2.41778 1.79063H10.8603V5.56283C10.8603 5.86049 11.1016 6.1017 11.3992 6.1017H15.5901L16.3749 7.11265V9.89187H14.884C14.5863 9.89187 14.3451 10.1331 14.3451 10.4307C14.3451 10.7284 14.5864 10.9696 14.884 10.9696H16.9138C17.2115 10.9696 17.4527 10.7284 17.4527 10.4307V6.92805C17.4527 6.80841 17.4128 6.69201 17.3395 6.59752Z",
        fillOpacity: '1'
    },
    {
        d: "M4.25019 7.16138H1.77129C1.47363 7.16138 1.23242 7.40262 1.23242 7.70025C1.23242 7.99791 1.47367 8.23912 1.77129 8.23912H4.25015C4.54781 8.23912 4.78902 7.99787 4.78902 7.70025C4.78906 7.40262 4.54781 7.16138 4.25019 7.16138Z",
        fillOpacity: '1'
    },
    {
        d: "M5.48894 5.04175H0.890434C0.592809 5.04175 0.351562 5.28299 0.351562 5.58065C0.351562 5.87831 0.592809 6.11952 0.890434 6.11952H5.48894C5.7866 6.11952 6.02781 5.87828 6.02781 5.58065C6.02781 5.28303 5.7866 5.04175 5.48894 5.04175Z",
        fillOpacity: '1'
    },
    {
        d: "M6.3698 2.92212H1.77129C1.47363 2.92212 1.23242 3.16337 1.23242 3.46099C1.23242 3.75865 1.47367 3.99986 1.77129 3.99986H6.3698C6.66746 3.99986 6.90867 3.75862 6.90867 3.46099C6.90871 3.16337 6.66746 2.92212 6.3698 2.92212Z",
        fillOpacity: '1'
    }
    ],
  }
}

export default iconsMap
